module.exports = __webpack_public_path__ + "static/media/Costillar de cerdo.5233ff82.webp";